import { Component, Inject, OnInit, Input, EventEmitter, Output, OnChanges, SimpleChanges } from '@angular/core';
import { SortbyPipe } from '@netfoundry-ui/ui/pipes';
import { AgentService, ApiService, AuthProviderService } from '@netfoundry-ui/shared/services';
import { Agent, AuthProvider } from '@netfoundry-ui/shared/model';
import { GrowlerData, GrowlerService } from '@netfoundry-ui/shared/growler';
import { ActivatedRoute, Router } from '@angular/router';
import _, { cloneDeep, unset, isEmpty } from 'lodash';
import moment from 'moment';
import { Subject, Subscription } from 'rxjs';
import {Location} from "@angular/common";


@Component({
    selector: 'app-auth-provider-modal',
    templateUrl: './auth-provider-modal.component.html',
    styleUrls: ['./auth-provider-modal.component.scss'],
    standalone: false
})
export class AuthProviderModalComponent implements OnInit, OnChanges {
  @Input() isModal = false;
  @Input() formData: any = {};
  close: EventEmitter<any> = new EventEmitter<any>();

    isEditing = false;

    formView = 'simple';

    errMap:  any = {};
    timeout = Date.now() + 10 * 60 * 1000; 

    saveSubject = new Subject<boolean>;
    mappingConfigUpdateSubject = new Subject<boolean>;
     formInit = false;
    issuerError;
    issuerErrorMessage
    scopesError;
    scopesErrorMessage
    audienceError;
    audienceErrorMessage
    promptError;
    promptErrorMessage
    clientSecretError;
    clientSecretErrorMessage
    clientIdError;
    clientIdErrorMessage;
    nameError;
    nameErrorMessage;
    typeError;
    typeErrorMessage;

    moreActions: any[] = [];
    protected isLoading = false;
    initData: any = {};
    @Output() dataChange: EventEmitter<any> = new EventEmitter<any>();
    public errors: any = {};
    basePath = '';
    previousRoute;
    errorState = false;
    protected usePreviousLocation = true;
    subscription: Subscription = new Subscription();
    @Input() entityId: string;
    baseHref: any;
    processing = false;
    promptTypes = [
        { 
    value: 'none', 
    label: 'Silent Authentication (none)', 
  },
  { 
    value: 'login', 
    label: 'Force user to login (login)', 
  },
  { 
    value: 'consent', 
    label: 'Ask user to consent (consent)', 
  },
{ 
    value: 'select_account', 
    label: 'Allow user to select account (select_account)', 
  },
  { 
    value: 'create', 
    label: 'Show registration or signup (create)', 
  }
    ]

    model: AuthProvider;
    orgId;
    frontdoorId;
    networkControllerId;
    networkId;
    providerTypes = [];
    token;
    isV2
    responseNotFound= false;
        hostData: any;
    hasAllocatedIps = false;
    providerSelected = false;
    checked: boolean = true;
    _dataChange = false;



    constructor(
        private svc: AuthProviderService,
        private agentService: AgentService,
        private apiService: ApiService,
        public growlerService: GrowlerService,
        private location: Location,
        protected router?: Router,
        protected route?: ActivatedRoute,
    ) {
    this.previousRoute = router?.getCurrentNavigation()?.previousNavigation?.finalUrl?.toString();
        this.subscription.add(
            this.route?.params?.subscribe(params => {
                const id = params['id'];
                if (isEmpty(id)) {
                    this.entityId = 'create';
                } else {
                  this.entityId = id;
                }
            })
        );
        this.subscription.add(
            router?.events.subscribe((event: any) => {
                  if (!event?.snapshot?.routeConfig?.path) {
                      return;
                  }
                  const pathSegments = event.snapshot.routeConfig.path.split('/');
                  this.basePath = pathSegments[0];
                
            })
        );
        this.initBaseHref();

    }

    ngOnInit() {
        this.subscription.add(
            this.apiService.currentTenant.subscribe((tenant) => {
                this.agentService.getAccountById(tenant.id).subscribe((frontdoor: any) => {
                    this.frontdoorId = frontdoor.id;
                    if(frontdoor.version === 2) {
                        this.isV2 = true;
                    } else {
                        this.isV2 = false;
                    }
                    this.getProviderTypes()
                    if (this.entityId === 'create') {
                        this.formData = new AuthProvider();
                        this.initData = cloneDeep(this.formData);
                        this.entityUpdated();
                        return;
                    } else {
                        this.isEditing = true;
                        this.isLoading = true;
                        this.getSingleAuthProvider();
                    }
                })
            })
        );
        this.formInit = true;


    }


    getProviderTypes() {
    this.svc.getAuthProviderTypes(this.frontdoorId, this.isV2).subscribe((data: any) => {
        this.providerTypes = data._embedded.authProviderTypeList

    })
}

    onKeyDown(event: KeyboardEvent) {
        if (event.key === ' ') {
            event.preventDefault();
            const element = event.target as HTMLElement;
            element.blur();
            element.focus();
        }
    }

    toggleChecked() {
        this.checked = !this.checked;
    }
      entityUpdated() {
            if (this.formData.id) {
            }
            
            unset(this.formData, '_links');
            this.initData = cloneDeep(this.formData);
        }

      headerActionRequested(action: any) {
        switch(action.name) {
            case 'save':
                this.save();
                break;
            case 'close':
                this.closeForm();
                break;
            case 'toggle-view':
                this.formView = action.data;
                break;
            }
        }

    onTypeChange() {
        if (this.formData.type === 'OIDC') {
        this.formData.data.supports_pkce = this.checked;
        this.formData.data.prompt = 'login'; 
        } 
    }

        processErrors(errorResponse: any) {
            const errors: string[] = errorResponse?.error?.errors || [];
            const nameError = errors.find(e => e.includes('name'));
            const typeError = errors.find(e => e.includes('type'));
            const issuerError = errors.find(e => e.includes('issuer'));
            const audienceError = errors.find(e => e.includes('audience'));
            const scopesError = errors.find(e => e.includes('scopes'))
            const promptError = errors.find(e => e.includes('prompt'))
            const clientSecretError = errors.find(e => e.includes('client_secret'))
            const clientIdError = errors.find(e => e.includes('client_id'))
            if(issuerError) {
                this.issuerError = true;
                this.issuerErrorMessage =  issuerError.split(':').slice(1).join(':').trim();
            }
            if(audienceError) {
                this.audienceError = true;
                this.audienceErrorMessage =  audienceError.split(':').slice(1).join(':').trim();
            }
            if(scopesError) {
                this.scopesError = true;
                this.scopesErrorMessage =  scopesError.split(':').slice(1).join(':').trim();
            }
            if(nameError) {
                this.nameError = true;
                this.nameErrorMessage =  nameError.split(':').slice(1).join(':').trim();
            }
            if(typeError) {
                this.typeError = true;
                this.typeErrorMessage =  typeError.split(':').slice(1).join(':').trim();
            }
            if(promptError) {
                this.promptError = true;
                this.promptErrorMessage =  promptError.split(':').slice(1).join(':').trim();
            }
            if(clientIdError) {
                this.clientIdError = true;
                this.clientIdErrorMessage =  clientIdError.split(':').slice(1).join(':').trim();
            }
            if(clientSecretError) {
                this.clientSecretError = true;
                this.clientSecretErrorMessage =  clientSecretError.split(':').slice(1).join(':').trim();
            }
            else {
                this.growlerService.show(
                        new GrowlerData(
                            'error',
                            'Auth provider save request failed',
                            'Auth provider save request has failed.'
                    )
            );
            }
            
}

    closeForm(refresh = true, ignoreChanges = false, data?, event?) {
      if (!ignoreChanges && this._dataChange) {
          const confirmed = confirm('You have unsaved changes. Do you want to leave this page and discard your changes or stay on this page?');
          if (!confirmed) {
              return;
          }
      }
      if (this.isModal) {
          this.closeModal(refresh, ignoreChanges);
      } else {
          this.returnToListPage();
      }
  }

  save(event?: any) {
  this.processing = true;
  this.isLoading = true;

  
  const proms = [];

  // 1. Handle Subject logic for Editing mode
  if (this.isEditing) {
    this.saveSubject.next(true);
    const updateSubjectPromise = new Promise<boolean>((resolve) => {
      // Note: Consider taking(1) so this doesn't hang
      this.mappingConfigUpdateSubject.asObservable().subscribe((wasUpdated: boolean) => {
        resolve(wasUpdated);
      });
    });
    proms.push(updateSubjectPromise);
  } else {
    // If not editing, we push 'true' so the Promise.all logic stays consistent
    proms.push(Promise.resolve(true));
  }

  // 2. Branch between Create and Update
  // We wrap the observable in toPromise() or use a new Promise wrapper 
  // so Promise.all can actually track it.
  const httpCall = this.isEditing 
    ? this.svc.update( this.formData, this.frontdoorId,  this.formData.id, this.isV2)
    : this.svc.create(this.formData, this.frontdoorId, this.isV2 );

  const requestPromise = new Promise((resolve, reject) => {
    httpCall.subscribe({
      next: (result: any) => {
        if (this.isModal) {
          this.closeModal(true, true);
        } else {
          this.initData = this.formData;
          this.formData = result;
          this._dataChange = false;
          this.isLoading = false;
          this.returnToListPage()
        }
        resolve(true);
      },
      error: (err) => {
        this.processErrors(err);
        this.isLoading = false;
      }
    });
  });


  proms.push(requestPromise);

  // 3. Finalize
  Promise.all(proms)
    .then((results) => {
      // results[0] is the Subject, results[1] is the HTTP call
      if (results.every(res => res === true)) {
        this.returnToListPage();
        // TODO: Success message
      }
    })
    .catch(err => {
      // Handle errors here
    })
    .finally(() => {
      this.processing = false;
      this.isLoading = false;
    });
}

    initBaseHref() {
        try {
            const base = document?.querySelector('base');
            this.baseHref = base ? base.getAttribute('href') : '/';
        } catch (error) {
            this.baseHref = '/';
        }
    }

  getSingleAuthProvider() {
    return this.svc.getSingleAuthProvider(this.frontdoorId, this.entityId, this.isV2).subscribe({
      next: (entity: AuthProvider) => {
        this.formData = entity;
        this.formData.type = entity.type;
        this.initData = cloneDeep(this.formData);
        this.entityUpdated();
        this.isLoading = false;
      },
      error: (err) => {
        this.growlerService.show(
        new GrowlerData(
            'error',
            'Error',
            'Error retrieving authentication provider data.',
        )
    );
      }
    })
  }
    
    ngOnChanges(changes: SimpleChanges) {
        this.isEditing = !isEmpty(this.formData.id);
    }

    returnToListPage() {
      // Authentication is a tab on the HTTP shares page, not a page of its own.
      this.router?.navigateByUrl(`${this.basePath}/http-shares?tab=authentication`);

  }
    
    closeModal(refresh = true, ignoreChanges = false, data?: any, event?: any): void {
        this.close.emit({refresh: refresh});
        if (event) {
            event.stopPropagation();
        }
    }


    /**
     * True when this form is showing an existing entity. Derived from the route/input
     * rather than the loaded record, so the header title doesn't briefly read
     * "Create New ..." while the record is still being fetched.
     */
    get isExistingEntity(): boolean {
        return !isEmpty(this.formData?.id) || (!isEmpty(this.entityId) && this.entityId !== 'create');
    }

}
